const STATE_NAMES = {
    ac: 'Acre',
    al: 'Alagoas',
    ap: 'Amapá',
    am: 'Amazonas',
    ba: 'Bahia',
    ce: 'Ceará',
    df: 'Distrito Federal',
    es: 'Espírito Santo',
    go: 'Goiás',
    ma: 'Maranhão',
    mt: 'Mato Grosso',
    ms: 'Mato Grosso do Sul',
    mg: 'Minas Gerais',
    pa: 'Pará',
    pb: 'Paraíba',
    pr: 'Paraná',
    pe: 'Pernambuco',
    pi: 'Piauí',
    rj: 'Rio de Janeiro',
    rn: 'Rio Grande do Norte',
    rs: 'Rio Grande do Sul',
    ro: 'Rondônia',
    rr: 'Roraima',
    sc: 'Santa Catarina',
    sp: 'São Paulo',
    se: 'Sergipe',
    to: 'Tocantins',
    rm: 'Itália', // Roma, the only station abroad
};

// lowercase, no accents, "106,9" and "106.9" equal
export const normalizeText = (text) => (text || '')
    .toString()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .replace(/(\d),(\d)/g, '$1.$2');

// enderecoCEP looks like "City/UF - CEP: 00000-000"
const _splitLocation = (enderecoCEP) => ((enderecoCEP || '').split(' - ')[0].split('/'));

export const extractUF = (enderecoCEP) => {
    const parts = _splitLocation(enderecoCEP);

    return parts.length === 2 ? parts[1].trim().toLowerCase() : '';
};

export const extractCity = (enderecoCEP) => _splitLocation(enderecoCEP)[0].trim();

// Only states that have at least one station, sorted by name.
export const buildStateOptions = (affiliates) => {
    // Array.from, not spread: the loose Babel preset turns [...set] into [].concat(set)
    const ufs = Array.from(new Set(affiliates.map((affiliate) => extractUF(affiliate.enderecoCEP)).filter(Boolean)));

    return ufs
        .map((uf) => ({ label: STATE_NAMES[uf] || uf.toUpperCase(), value: uf }))
        .sort((a, b) => a.label.localeCompare(b.label, 'pt-BR'));
};

const _tokens = (text) => normalizeText(text).split(/[^a-z0-9.]+/).filter(Boolean);

// every search word must be the start of a word in the text
const _matchesAll = (words, text) => {
    const tokens = _tokens(text);

    return words.every((word) => tokens.some((token) => token.startsWith(word)));
};

// Searches station name, city and frequency. Only if nothing matches, the state (name or UF) is searched too,
// so "paulo" finds the city São Paulo and not every station in the state of São Paulo.
export const filterAffiliates = (affiliates, { state = null, search = '' } = {}) => {
    const words = _tokens(search);
    const inState = affiliates.filter((affiliate) => !state || extractUF(affiliate.enderecoCEP) === state.toLowerCase());

    if (words.length === 0) {
        return inState;
    }

    const stationText = (affiliate) => `${affiliate.filial} ${extractCity(affiliate.enderecoCEP)}`;
    const matches = inState.filter((affiliate) => _matchesAll(words, stationText(affiliate)));

    if (matches.length > 0) {
        return matches;
    }

    return inState.filter((affiliate) => {
        const uf = extractUF(affiliate.enderecoCEP);

        return _matchesAll(words, `${stationText(affiliate)} ${uf} ${STATE_NAMES[uf] || ''}`);
    });
};
